import Theme from './Theme.js';
import Overlay from './Overlay.js';
import Background from './Background.js';
import styles from './OverlayApplicationPro.module.css';
import Logo from './Logo.js';
import ArticleTitlePrice from './ArticleTitlePrice.js';
import ButtonCallToAction from './ButtonCallToAction.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
// Note these are special OverlayApplicationPro-specific components
import ArticleTitle from './OverlayApplicationProArticleTitle.js';
import ArticleSubtitle from './OverlayApplicationProArticleSubtitle.js';

const OverlayApplicationPro = () => {
  const { articleLink } = useSearchParamOrDefaultProps();

  return (
    <Theme>
      <Overlay>
        <Background>
          <div className={styles.overlayApplicationProWrapper}>
            <Logo />
            <ArticleTitle />
            <ArticleTitlePrice />
            <ArticleSubtitle />
            <ButtonCallToAction href={articleLink} />
          </div>
        </Background>
      </Overlay>
    </Theme>
  );
};

OverlayApplicationPro.displayName = 'OverlayApplicationPro';

export default OverlayApplicationPro;
